<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/kaiguangui" />
          <div class="ProductImages">
              <div class="image-div">
                <p>高低压成套电气开关柜；</p>
                <p>各类非标控制柜订制。</p>
                <img :src="baseApi+ 'upload/product/7001.png'">
              </div>
            <div class="image-div">
                <img :src="baseApi+ 'upload/product/7002.png'">
              </div>
            <div class="image-div">
              <img :src="baseApi+ 'upload/product/7003.png'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  display: flex;
  padding: 30px;
  .image-div {
    width: 30%;
    margin: 10px;
    img {
      width: 100%;
      margin: 20px 0;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/kaiguangui.vue